/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetFeeInfo } from './assetFeeInfo';

/**
 * Fees info
 */
export interface FeesInfo {
  ledgerId: string;
  fees: Array<AssetFeeInfo>;
}
